"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeightByFlag = void 0;
const getHeightByFlag = _ref => {
  let {
    isDynamicHeight,
    value
  } = _ref;
  if (isDynamicHeight) return 'auto';
  return value;
};
exports.getHeightByFlag = getHeightByFlag;